import { createFileRoute } from '@tanstack/react-router'
import PropostasSplitPage from '@/pages/propostas/propostas-split-page'
import { ProtectedRoute, RequireModule } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'
import { MODULES } from '@/constants/modules'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/propostas',
)({
  component: function PropostasListRoute() {
    const { dashboardId } = Route.useParams()
    return (
      <RequireModule module={MODULES.PROPOSTAS} dashboardId={dashboardId}>
        <ProtectedRoute
          anyOf={[CAPABILITIES.PROPOSTAS_ALL, CAPABILITIES.PROPOSTAS_OWN]}
          dashboardId={dashboardId}
        >
          <PropostasSplitPage />
        </ProtectedRoute>
      </RequireModule>
    )
  },
})
